import Request from './request';
import consts from "@/consts.js";
// Vuex
import store from '@/store.js';
// i18n
import i18n from '@/i18n';
// Self-made Snackbar
import snackbar from '@/plugins/snackbar';

async function fetch(data) {
    return Request('get', "api/stock-materials", data);
}

async function fetchAll(data) {
    if (!data) data = {};
    return Request('get', "api/stock-materials", Object.assign({},data,{
        itemsPerPage: consts.limitAll,
        limit: consts.limitAll,
    }));
}

async function getSimpleStockMaterials(data) {
    if (!data) data = {};
    return Request('get', "api/stock-materials/get-simple-stock-materials", Object.assign({},data,{
        itemsPerPage: consts.limitAll,
        limit: consts.limitAll,
    }));
}

async function saveNewStockMaterials(data) {
    if (!data) data = {};
    return Request('post', "api/stock-materials/save-new-stock-materials", data);
}

async function fetchAllForSelect(data) {
    if (!data) data = {};
    return Request('get', "api/stock-materials/select", Object.assign({},data,{
        itemsPerPage: consts.limitAll,
        limit: consts.limitAll,
    }),false, false, true);
}

async function saveStockMaterials(data) {
    return Request("post", "api/stock-materials/batch-save", data)
}

async function getCategories(data) {
    if (!data) data = {};
    return Request("get", "api/stock-materials/getCategories",data)
}

async function exports(data) {
    store.dispatch("fullscreenLoading");
    const response = await Request("get", "api/stock-materials/export", data)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function allSave(data) {
    return Request("post", "api/stock-materials/all-save", data)
}

async function imports(ID, file) {// 导入
    var data = new FormData();
    data.append("excel", file);
    return Request('post', "api/stock-materials/import?stock_id=" + ID, data);
}

async function getMaterialStocks(data) {
    return Request("get", "api/stock-materials/get-material-stocks",data)
}

async function singleBatchSave(id,data) {
    return Request("get", "api/stock-materials/singleBatchSave/" + id, data)
}

async function updateMaterialUnit(id, data) {
    return Request("get", "api/stock-materials/update-material-unit/" + id, data)
}

export default {
    fetch,
    fetchAll,
    getSimpleStockMaterials,
    saveNewStockMaterials,
    fetchAllForSelect,
    saveStockMaterials,
    getCategories,
    exports,
    allSave,
    imports,
    getMaterialStocks,
    singleBatchSave,
    updateMaterialUnit
};